import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import Icon from "../../common/icon/icon.component.jsx"
import SectionContentTypes from "./content/ContentTypes.jsx"
import { AppContext, AccountFeatures } from "@lightspeed-invoicing/core-client/frontend";
import EventBus from "../../common/EventBus.js";
import SpanWrapper from '../../common/rich-text/feature-protection-wrappers/spanWrapper.component';
const uuidv4 = require('uuid/v4')

class EditButtonSectionModal extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            uniqueId: uuidv4(),
            modalId: this.props.modalId || 'template-sections-modal',
            sectionId: this.props.sectionId || '',
            documentId: this.props.documentId || '',
            variables: this.props.variables || {},
            edition: this.props.edition || false,
            editable: this.props.editable || false,
            onMouseEnter: this.props.onMouseEnter || function () { },
            onMouseLeave: this.props.onMouseLeave || function () { },
            onAddSection: this.props.onAddSection || function () { },
            marginTop: this.props.marginTop || '-1px',
            icon: this.props.icon || 'ellipsis-h',
            section: this.props.variables.sections.filter(s => s.id === this.props.sectionId)[0],
            modalOpened: false,
            documentType: this.props.variables ? this.props.variables.document.type : '',
        }
        this.removeSection = this.removeSection.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        let state = {
            edition: nextProps.edition || false,
            editable: nextProps.editable || false,
            sectionId: nextProps.sectionId || '',
            documentId: nextProps.documentId || '',
            modalId: nextProps.modalId || 'template-sections-modal',
        }
        this.setState(state)
    }

    removeSection(event) {
        event.preventDefault()
        AppContext.getApiClient().delete('/documents/' + this.state.documentId + '/sections/' + this.state.sectionId).then((response) => {
            if (!response.error) {
                EventBus.dispatch(EventBus.TopicProposalPreviewRefresh, {
                    sectionId: this.state.sectionId
                })
            }
        })
    }

    moveTo(rank, up) {
        return function (event) {
            event.preventDefault()
            const newOrder = []
            const currentOrder = this.props.variables.sections.map(s => s.id)
            for (let index in currentOrder) {
                if (currentOrder[index] !== this.state.sectionId && !up) {
                    newOrder.push(currentOrder[index])
                }
                if (index == rank) {
                    newOrder.push(this.state.sectionId)
                }
                if (currentOrder[index] !== this.state.sectionId && up) {
                    newOrder.push(currentOrder[index])
                }
            }
            AppContext.getApiClient().patch('/documents/' + this.state.documentId, {
                sectionsOrder: newOrder,
            }).then(r => {
                EventBus.dispatch(EventBus.TopicProposalPreviewRefresh, {
                    sectionId: this.state.sectionId
                })
            })
        }.bind(this)
    }

    render() {
        let button = ''
        if (this.state.editable) {
            button = <div style={{
                position: 'absolute',
                marginLeft: '-37px',
                marginTop: this.state.marginTop,
            }}>
                <div className="btn-group" role="group">
                    <button id={this.state.uniqueId}
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="btn btn-sm btn-outline-primary btn-toolbar"
                        onMouseEnter={this.state.onMouseEnter}
                        onMouseLeave={this.state.onMouseLeave}
                    >
                        <Icon value={'ellipsis-h'} />
                    </button>
                    <div className="dropdown-menu" aria-labelledby={this.state.uniqueId}>
                        {this.state.section.attributes.rank != 0 ? <button
                            className="dropdown-item text-primary"
                            onClick={this.moveTo(this.state.section.attributes.rank - 1, true)}
                        >
                            <Icon value={'arrow-up'} className={'mr-1'} />
                            <FormattedMessage
                                id="proposal.section.menu.move_up"
                                defaultMessage="Move up"
                            />
                        </button> : ''}
                        {this.state.section.attributes.rank != (this.state.variables.sections.length - 1) ? <button
                            className="dropdown-item text-primary"
                            onClick={this.moveTo(this.state.section.attributes.rank + 1, false)}
                        >
                            <Icon value={'arrow-down'} className={'mr-1'} />
                            <FormattedMessage
                                id="proposal.section.menu.move_down"
                                defaultMessage="Move down"
                            />
                        </button> : ''}
                        <button className="dropdown-item text-primary" onClick={() => SectionContentTypes.openSectionEditor(this.state.sectionId)}>
                            <Icon value={'edit'} className={'mr-1'} />
                            <FormattedMessage
                                id="proposal.section.menu.edit"
                                defaultMessage="Edit"
                            />
                        </button>
                        {this.state.section.attributes.contentType !== 'empty-space' ? <button
                            className="dropdown-item text-primary" onClick={e => {
                                e.preventDefault()
                                this.state.onAddSection()
                            }}>
                            <Icon value={'plus'} className={'mr-1'} />
                            <FormattedMessage
                                id="proposal.section.menu.add_section"
                                defaultMessage="Add content after..."
                            />
                        </button> : ''}

                        {!SectionContentTypes.getById(this.state.section.attributes.contentType, this.state.documentType).mandatory ? [
                            <div key={1} className="dropdown-divider" />,
                            <SpanWrapper
                                isProtected={this.state.section.attributes.contentType === 'payment'}
                                onClick={this.removeSection}
                                accountFeatureKey={AccountFeatures.FeatureRemovePaymentButton}
                                className={'dropdown-item text-danger'}
                                redirectToAccount={true}
                                protectedClassName={'dropdown-item'}
                                key={2}>
                                <span>
                                    <Icon value={'trash'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="proposal.section.menu.remove"
                                        defaultMessage="Remove"
                                    />
                                </span>
                            </SpanWrapper>,
                        ] : ''}
                    </div>
                </div>

            </div>
        }
        return (
            <div>
                {button}
            </div>

        );
    }
}

export default injectIntl(EditButtonSectionModal)





// WEBPACK FOOTER //
// ./src/template/sections/editbutton.component.jsx